.card {
  /* Components lay themselves out by the space they are in, not the window. */
  container-type: inline-size;
  background: var(--surface-raised);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
}

.pad-3 {
  padding: var(--space-3);
}
.pad-5 {
  padding: var(--space-5);
}

.raised {
  box-shadow: var(--shadow-sm);
}

.interactive {
  cursor: pointer;
  transition:
    border-color var(--duration-fast) var(--ease-out),
    box-shadow var(--duration-fast) var(--ease-out);
}

.interactive:hover {
  border-color: var(--border-strong);
  box-shadow: var(--shadow-md);
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--space-3);
  margin-bottom: var(--space-3);
}
